export default class NameInput {

    constructor({x, y, scene, width, color, text="", fontSize = 24, labelText = "", onUpdate = () => null}){
        this.scene = scene;
        this.input = this.scene.add.rexCanvasInput(
            {
                width,
                x,
                y,
                //background: {
                    // Solution A
                //    'focus.stroke': 'red',
                //},
                // Solution B
                // focusStyle: {
                //     stroke: 'red',
                // },

                style: {
                    fontSize,
                    color,
                    fontFamily: "Splurge",
                    backgroundBottomY: 5,
                    backgroundHeight: fontSize,

                    // Solution A
                    'cursor.color': 'black',
                    'cursor.backgroundColor': 'white',
                },
                // Solution B
                cursorStyle: {
                     color: 'black',
                     backgroundColor: 'white'
                },

                text: text,
                inputType: "text",
                textArea: false,
                selectAll: true,
                maxLength: 10,
                minLength: 3,
                onClose: () => {
                    if(this.input.text.length < 3){
                        this.input.setText("Nope");
                    }
                }
            }
        )
        this.input.on("textchange", (text) => {
            onUpdate(text);
        })
    }
}